// extracted by mini-css-extract-plugin
module.exports = {"container":"a2c79c7e7d--container--U60_o","image_container":"a2c79c7e7d--image_container--DlB92","fat_panel":"a2c79c7e7d--fat_panel--tSveT"};